import {
  TRIGGER_RESEARCH_DECK_REQUEST,
  TRIGGER_RESEARCH_DECK_SUCCESS,
  TRIGGER_RESEARCH_DECK_FAILURE,
  TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_REQUEST,
  TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_SUCCESS,
  TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_FAILURE,
  TRIGGER_DECK_REFINE_DIAGRAM_REQUEST,
  TRIGGER_DECK_REFINE_DIAGRAM_SUCCESS,
  TRIGGER_DECK_REFINE_DIAGRAM_FAILURE,
  RESET_RESEARCH_DECK_STATE,
} from "../actions/researchDeckActions";

const initialState = {
  submitStatus: "idle", // idle | submitting | success | error
  lastRunId: null,
  lastTopic: null,
  lastVoiceMode: null,
  error: null,
  // Diagram sub-flow (populated only when the deck was submitted with a
  // diagram config). `diagramRefineCount` is the count of refines the creator
  // has kicked off from the inline confirm panel — capped at MAX_REFINES by
  // the UI so a stuck scope doesn't loop forever.
  confirmScopeStatus: "idle",
  refineDiagramStatus: "idle",
  diagramRefineCount: 0,
};

const researchDeckReducer = (state = initialState, action) => {
  switch (action.type) {
    case TRIGGER_RESEARCH_DECK_REQUEST:
      return {
        ...state,
        submitStatus: "submitting",
        lastRunId: action.payload?.runId || null,
        lastTopic: action.payload?.topic || null,
        lastVoiceMode: action.payload?.voiceMode || null,
        error: null,
        confirmScopeStatus: "idle",
        refineDiagramStatus: "idle",
        diagramRefineCount: 0,
      };

    case TRIGGER_RESEARCH_DECK_SUCCESS:
      return {
        ...state,
        submitStatus: "success",
        error: null,
      };

    case TRIGGER_RESEARCH_DECK_FAILURE:
      return { ...state, submitStatus: "error", error: action.error };

    case TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_REQUEST:
      return { ...state, confirmScopeStatus: "submitting", error: null };
    case TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_SUCCESS:
      return { ...state, confirmScopeStatus: "success" };
    case TRIGGER_DECK_CONFIRM_DIAGRAM_SCOPE_FAILURE:
      return { ...state, confirmScopeStatus: "error", error: action.error };

    case TRIGGER_DECK_REFINE_DIAGRAM_REQUEST:
      return {
        ...state,
        refineDiagramStatus: "submitting",
        diagramRefineCount: state.diagramRefineCount + 1,
        error: null,
      };
    case TRIGGER_DECK_REFINE_DIAGRAM_SUCCESS:
      return { ...state, refineDiagramStatus: "success" };
    case TRIGGER_DECK_REFINE_DIAGRAM_FAILURE:
      return { ...state, refineDiagramStatus: "error", error: action.error };

    case RESET_RESEARCH_DECK_STATE:
      return initialState;

    default:
      return state;
  }
};

export default researchDeckReducer;
